import SectionMessage from '@atlaskit/section-message';
import { token } from '@atlaskit/tokens';

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Action, redirect } from 'redux-first-router';

import config from 'appconfig';
import { Dimensions } from 'components/visuals';
import { styled } from 'styled-components';
import t from 'modules/i18n/intl';

import { messages } from '../messages';
import { getMACUserChannel, selectIsSwitchedUser, selectSwitchedUser } from '../duck/selectors';
import { restoreSwitchUserEmail } from '../duck/actions/configUser';
import { fetchGetCustomerByEmail } from '../duck/actions/contact';
import { getCurrentContactEmail } from 'modules/auth/selectors';
import { route } from '../duck/actions/landing';
import { StyledActionsButtonLink } from './licensesExpandedRow/StyledComponents';
import { checkFeatureGate, FeatureFlags } from '../../../util/statsig';
import { CloudSiteMigrationsLink } from '../../../util/constants';
import { State } from '../../../model/State';

const StyledMainMACHeader = styled.h1`
  margin: ${Dimensions.unit}px 0 ${Dimensions.unit * 3}px;
  color: ${token('color.text', '#172B4D')};
`;

const MigrationCloudsBanner = styled.div`
  padding: ${Dimensions.unit * 2}px 0;
`;

const cloudSiteMigrations = (chunks) => (
  <a rel="noopener noreferrer" target="_blank" href={CloudSiteMigrationsLink}>
    {chunks}
  </a>
);

export const ppcLink = (chunks) => (
  <a rel="noopener noreferrer" target="_blank" href={config.ppcUrl}>
    {chunks}
  </a>
);

const date = (chunks) => <strong>{chunks}</strong>;

const MACPageHeader = () => {
  const dispatch = useDispatch();

  const currentUserEmail = useSelector(getCurrentContactEmail) || '';
  const switchedUserEmail = useSelector(selectSwitchedUser) || '';
  const { isPartner } = useSelector((state: State) => getMACUserChannel(state));
  const isSwitchedUser = useSelector(selectIsSwitchedUser) || false;
  const migrationCloudsFunctionality = checkFeatureGate(
    FeatureFlags.MIGRATION_CLOUDS_BANNER_FOR_PARTNERS,
  );

  const handleEmailRestore = () => {
    if (currentUserEmail) {
      dispatch(fetchGetCustomerByEmail(currentUserEmail));
    }
    dispatch(restoreSwitchUserEmail());
    dispatch(redirect(route() as Action));
  };
  return (
    <>
      {isPartner && migrationCloudsFunctionality && (
        <MigrationCloudsBanner>
          <SectionMessage appearance="warning">
            {t(messages.migrationCloudsBanner, {
              cloudSiteMigrations,
              ppcLink,
              date,
            })}
          </SectionMessage>
        </MigrationCloudsBanner>
      )}
      <StyledMainMACHeader>
        <FormattedMessage {...messages.macMainHeader} />
      </StyledMainMACHeader>
      {isSwitchedUser && (
        <>
          <SectionMessage
            appearance="information"
            actions={[
              <StyledActionsButtonLink
                key="mac-revert-switched-user-button"
                onClick={handleEmailRestore}
                data-cy="mac-revert-switched-user-button"
              >
                <FormattedMessage {...messages.switchUserButtonRevert} />
              </StyledActionsButtonLink>,
            ]}
            testId="mac-switched-user-main-banner"
          >
            <FormattedMessage
              {...messages.macMainSwitchedUserBanner}
              values={{
                switchedUserEmail,
              }}
            />
          </SectionMessage>
          <br />
        </>
      )}
    </>
  );
};

export default MACPageHeader;
